import { useQuery } from '@tanstack/react-query';
import { GetGpQrEntity, UserWalletTransactionService } from 'services/openapi';

import { PointQueryKeys } from './constants';
import { isEmpty } from 'lodash';

type GetGpQrRequest = {
  amount: string;
  enabled?: boolean;
  requestId?: number;
};

export const useGetPointQRGalaxyPayQuery = (variables: GetGpQrRequest) => {
  const { amount, enabled = true, requestId = 0 } = variables;
  const queryKey = [PointQueryKeys.GET_QRCODE_GALAXY_PAY, amount, requestId];

  const {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  } = useQuery<GetGpQrEntity, Error>({
    queryKey,
    queryFn: () =>
      UserWalletTransactionService.transactionControllerGetGalaxyPayQr(amount),
    retry: 0,
    refetchOnWindowFocus: false,
    enabled: enabled && !isEmpty(variables) && amount !== '0' && amount !== '',
  });

  return {
    isLoading,
    isLoadingError,
    isFetching,
    error,
    data: data,
    isError,
    queryKey,
    refetch,
  };
};
